// extracted by mini-css-extract-plugin
export default {"loader-backdrop-indicator":"GlobalLoader_loader-backdrop-indicator__K-Udv"};